console.log('[TN] product JS loaded');
function initTNProductInteractions(root = document) {
  /* TABS */
  const tabsRoot = root.querySelector('.tabs');
  if (tabsRoot && !tabsRoot.__tnTabsBound) {
    tabsRoot.__tnTabsBound = true; // prevent double-binding
    tabsRoot.addEventListener('click', (e) => {
      const btn = e.target.closest('.tabs-btn');
      if (!btn) return;
      const tabKey = btn.dataset.tab;

      // buttons
      root.querySelectorAll('.tabs-btn').forEach((b) => {
        const active = b.dataset.tab === tabKey;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active);
        const label = active ? (b.dataset.activeLabel || b.dataset.label) : (b.dataset.label || b.textContent);
        if (label) b.textContent = label;
      });

      // panels (instant, no easing)
      root.querySelectorAll('.tabs-panel').forEach((p) => {
        const show = p.id === `tab-${tabKey}`;
        p.classList.toggle('is-active', show);
        p.toggleAttribute('hidden', !show);
        p.style.display = show ? 'block' : 'none';
      });
    });

    // deep link like #tab=howto
    const match = location.hash.match(/tab=([\w-]+)/);
    const start = match && match[1];
    const initialBtn =
      (start && root.querySelector(`.tabs-btn[data-tab="${start}"]`)) ||
      root.querySelector('.tabs-btn.is-active');
    if (initialBtn) initialBtn.click();
  }

  /* ACCORDION */
  const accList = root.querySelector('.accordion-list');
  if (accList && !accList.__tnAccBound) {
    accList.__tnAccBound = true;

    const allowMultiple = !!accList.querySelector('.accordion[data-allow-multiple="true"]');

    function setState(accEl, open) {
      const btn = accEl.querySelector('.accordion-question-wrapper');
      const panel = accEl.querySelector('.accordion-answer-wrapper');
      if (!btn || !panel) return;
      btn.setAttribute('aria-expanded', String(open));
      panel.toggleAttribute('hidden', !open);
      const openIcon = accEl.querySelector('.accordion-open');
      const closeIcon = accEl.querySelector('.accordion-close');
      if (openIcon) openIcon.style.display = open ? 'none' : '';
      if (closeIcon) closeIcon.style.display = open ? '' : 'none';
    }

    accList.addEventListener('click', (e) => {
      const btn = e.target.closest('.accordion-question-wrapper');
      if (!btn) return;
      const acc = btn.closest('.accordion');
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      if (!allowMultiple) {
        accList.querySelectorAll('.accordion').forEach((sib) => {
          if (sib !== acc) setState(sib, false);
        });
      }
      setState(acc, !isOpen);
    });
  }
}

// run on normal page load
document.addEventListener('DOMContentLoaded', () => {
  console.log('[TN] product JS loaded');
  initTNProductInteractions(document);
});

// run when sections reload in Theme Editor
document.addEventListener('shopify:section:load', (e) => {
  initTNProductInteractions(e.target);
});